import { useMemo } from 'react';

import { PRODUCT_NAVIGATION_LINKS } from '~/consts/productsNavigation';

import useCanAccessLeLens from '~/hooks/useCanAccessLeLens';

import { UserType } from '~/types/responses/users';

import { filterNavigationLinksForUser } from '~/utils/navigationLinks';

export default function useProductNavigationLinks(user: App.User | UserType | null | undefined) {
  const canAccessLens = useCanAccessLeLens();
  return useMemo(
    () => filterNavigationLinksForUser(PRODUCT_NAVIGATION_LINKS, user, canAccessLens),
    [user, canAccessLens],
  );
}
